// Identity pages — shared across workspace-project and future runner shell.
// Consumed via sharedLibraries mechanism; each app's pages/index.js imports
// from here rather than maintaining its own copy.

import { login } from './auth/login.js'
import { signin } from './auth/signin.js'
import { signup } from './auth/signup.js'
import { signupConfirmation } from './auth/signup-confirmation.js'
import { resetPassword } from './auth/reset-password.js'
import { profile } from './profile.js'
import { admin, AdminSidebar, AdminSidebarLink, AdminUserRow } from './admin/admin.js'
import { adminTeams } from './admin/teams.js'
import { adminPermissions } from './admin/permissions.js'
import { adminActivityScoring, AdminActivityScoringRow } from './admin/activity-scoring.js'
import { adminDanger } from './admin/danger.js'
import { adminLogs, AdminLogDay, AdminLogGroup, AdminLogCalendar, AdminLogCalendarCell, AdminLogRow } from './admin/logs.js'
import { adminIntegrations } from './admin/integrations.js'
import { adminIntegrationsSupabase } from './admin/integrations-supabase.js'
import { adminIntegrationsGithub } from './admin/integrations-github.js'
import { adminIntegrationsGoogle } from './admin/integrations-google.js'
import { adminIntegrationsNpm } from './admin/integrations-npm.js'
import { adminIntegrationsGeneric } from './admin/integrations-generic.js'
import { adminIntegrationsMcp } from './admin/integrations-mcp.js'
import { adminStatus } from './admin/status.js'
import { capTable } from './admin/cap-table.js'

export {
  login,
  signin,
  signup,
  signupConfirmation,
  resetPassword,
  profile,

  // Admin pages
  admin,
  AdminSidebar,
  AdminSidebarLink,
  AdminUserRow,
  adminTeams,
  adminPermissions,
  adminActivityScoring,
  AdminActivityScoringRow,
  adminDanger,
  adminLogs,
  AdminLogDay,
  AdminLogGroup,
  AdminLogCalendar,
  AdminLogCalendarCell,
  AdminLogRow,
  adminIntegrations,
  adminIntegrationsSupabase,
  adminIntegrationsGithub,
  adminIntegrationsGoogle,
  adminIntegrationsNpm,
  adminIntegrationsGeneric,
  adminIntegrationsMcp,
  adminStatus,
  capTable
}

// Route map for the identity domain — used by workspace-project/pages/index.js
// and future runner shell (Phase 7).
export const identityRoutes = {
  '/login': login,
  '/signin': signin,
  '/signup': signup,
  '/signup-confirmation': signupConfirmation,
  '/reset-password': resetPassword,
  '/profile': profile,
  '/admin': admin,
  '/admin/teams': adminTeams,
  '/admin/permissions': adminPermissions,
  '/admin/activity-scoring': adminActivityScoring,
  '/admin/danger': adminDanger,
  '/admin/logs': adminLogs,
  '/admin/integrations': adminIntegrations,
  '/admin/integrations/supabase': adminIntegrationsSupabase,
  '/admin/integrations/github': adminIntegrationsGithub,
  '/admin/integrations/google': adminIntegrationsGoogle,
  '/admin/integrations/npm': adminIntegrationsNpm,
  '/admin/cap-table': capTable,
  '/admin/status': adminStatus
}
